<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="100%">
    <v-card>
      <v-card-title class="pt-2 pb-0">VISUALIZAR SOLICITUD</v-card-title>

      <v-divider class="my-2"></v-divider>

      <v-card-text class="pb-0">
        <v-row dense>
          <v-col cols="12" sm="6" md="3" lg="" v-for="(value, key) in solicitud" :key="key">
            <v-list class="py-1" dense>
              <v-list-item dense three-line>
                <v-list-item-content class="pa-0">
                  <v-list-item-title class="caption">{{ key.split('_').join(' ').toUpperCase() }}</v-list-item-title>
                  <v-list-item-subtitle class="caption">{{ value }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>

        <v-divider class="my-2"></v-divider>

        <v-simple-table dense>
          <thead>
            <tr>
              <th class="px-2 caption">Sede Origen</th>
              <th class="px-2 caption">Banco Origen</th>
              <th class="px-2 caption">Cuenta Origen</th>
              <th class="px-2 caption">Sede Destino</th>
              <th class="px-2 caption">Banco Destino</th>
              <th class="px-2 caption">Cuenta Destino</th>
              <th class="px-2 caption text-center">Archivo Adjunto</th>
              <th class="px-2 caption">Detalle</th>
              <th class="px-2 caption">Estado</th>
              <th class="px-2 caption">Tiene Reversión</th>
              <th class="px-2 caption">Importe</th>
              <th class="px-2 caption">Observaciones</th>
              <th class="px-2 caption">Fecha Desembolso</th>
              <th class="px-2 caption">Tipo Desembolso</th>
              <th class="px-2 caption">Historial</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(detalle, indice) in detalleSolicitud" :key="indice">
              <td class="px-2 caption" style="min-width: 100px">{{ detalle.sede_origen }}</td>
              <td class="px-2 caption" style="min-width: 100px">{{ detalle.banco_origen }}</td>
              <td class="px-2 caption">{{ detalle.cuenta_origen }}</td>
              <td class="px-2 caption" style="min-width: 100px">{{ detalle.sede_destino }}</td>
              <td class="px-2 caption" style="min-width: 100px">{{ detalle.banco_destino }}</td>
              <td class="px-2 caption">{{ detalle.cuenta_destino }}</td>
              <td class="px-2 caption text-center">
                <template v-if="mostrarAccionesArchivoAdjunto">
                  <v-menu v-if="detalle.archivo_id">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        small
                        v-bind="attrs"
                        v-on="on"
                        :disabled="cargando && detalleSeleccionadoId == detalle.id"
                        :loading="cargando && detalleSeleccionadoId == detalle.id">
                        <v-icon>mdi-file-document</v-icon>
                      </v-btn>
                    </template>

                    <v-list dense>
                      <v-list-item title="Ver Archivo" dense @click="obtenerArchivoAdjunto(detalle.id, indice)">
                        <v-list-item-title>Ver Archivo</v-list-item-title>
                      </v-list-item>

                      <v-list-item title="Cambiar Archivo" dense @click="abrirModalArchivo(detalle.id, indice)">
                        <v-list-item-title>Cambiar Archivo</v-list-item-title>
                      </v-list-item>

                      <v-list-item title="Eliminar Archivo" dense @click="eliminarArchivoAdjunto(detalle.id, indice)">
                        <v-list-item-title>Eliminar Archivo</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                  <v-btn
                    v-else
                    color="secondary"
                    small
                    title="Subir Archivo"
                    :disabled="cargando && detalleSeleccionadoId === detalle.id"
                    :loading="cargando && detalleSeleccionadoId === detalle.id"
                    @click="abrirModalArchivo(detalle.id, indice)">
                    <v-icon>mdi-file-upload</v-icon>
                  </v-btn>
                </template>

                <template v-else>
                  <v-btn
                    v-if="detalle.archivo_id"
                    color="primary"
                    small
                    :disabled="cargando && detalleSeleccionadoId == detalle.id"
                    :loading="cargando && detalleSeleccionadoId == detalle.id"
                    @click="obtenerArchivoAdjunto(detalle.id, indice)">
                    <v-icon>mdi-file-document</v-icon>
                  </v-btn>

                  <span v-else>-</span>
                </template>
              </td>
              <td class="px-2 caption" style="min-width: 400px">{{ detalle.detalle }}</td>
              <td class="px-2 caption">
                <span :style="{ color: obtenerColorEstadoDetalleSolicitud(detalle.estado) }">
                  {{ detalle.estado }}
                </span>
              </td>
              <td
                class="px-2 caption"
                :style="{
                  color: [estadosDetalleSolicitud.DESEMBOLSADO, estadosDetalleSolicitud.PAGADO_PARCIALMENTE].includes(
                    detalle.estado,
                  )
                    ? detalle.detalle_solicitud_reversion_id
                      ? '#4caf50'
                      : '#f44336'
                    : '#9e9e9e',
                }">
                <span>
                  {{
                    [estadosDetalleSolicitud.DESEMBOLSADO, estadosDetalleSolicitud.PAGADO_PARCIALMENTE].includes(
                      detalle.estado,
                    )
                      ? detalle.detalle_solicitud_reversion_id
                        ? 'Sí'
                        : 'No'
                      : 'N/A'
                  }}
                </span>
              </td>
              <td class="px-2 caption text-right">{{ detalle.importe }}</td>
              <td class="px-2 caption" style="min-width: 400px">{{ detalle.observaciones }}</td>
              <td class="px-2 caption">{{ detalle.fecha_desembolso }}</td>
              <td class="px-2 caption">{{ detalle.tipo_desembolso }}</td>
              <td class="px-2 caption">
                <v-btn
                  color="secondary"
                  small
                  title="Ver Historial"
                  :disabled="cargandoHistorialDetalle && detalleSeleccionadoId === detalle.id"
                  :loading="cargandoHistorialDetalle && detalleSeleccionadoId === detalle.id"
                  @click="verHistorial(detalle.id)">
                  <v-icon>mdi-history</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar()"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>

    <ModalVerPdf ref="modalVerPdfRef" />

    <ModalArchivoRespaldo
      ref="modalArchivoRespaldoRef"
      respaldoDe="detalle-solicitud"
      @actualizadoArchivoAdjunto="actualizadoArchivoAdjunto" />

    <ModalVisualizarHistorialDetalleSolicitud
      ref="modalVisualizarHistorialDetalleSolicitudRef"
      @loadingStart="cargandoHistorialDetalle = true"
      @loadingEnd="cargandoHistorialDetalle = false" />
  </v-dialog>
</template>

<script>
import moment from 'moment';
import { ESTADOS_DETALLE_SOLICITUD, obtenerColorEstadoDetalleSolicitud, TIPOS_SOLICITUD } from '../utils';
import DetalleSolicitudService from './../services/detalle-solicitud';
import ModalVerPdf from './ModalVerPdf';
import ModalArchivoRespaldo from './ModalArchivoRespaldo';
import ModalVisualizarHistorialDetalleSolicitud from './ModalVisualizarHistorialDetalleSolicitud';

export default {
  name: 'ModalVisualizarSolicitud',
  components: {
    ModalVerPdf,
    ModalArchivoRespaldo,
    ModalVisualizarHistorialDetalleSolicitud,
  },
  props: {
    mostrarAccionesArchivoAdjunto: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      solicitud: null,
      detalleSolicitud: [],
      cargando: false,
      detalleSeleccionadoId: null,
      cargandoHistorialDetalle: false,
      estadosDetalleSolicitud: ESTADOS_DETALLE_SOLICITUD,
    };
  },
  methods: {
    abrir(data) {
      this.solicitud = {
        numero: data.numero,
        sede_origen: data.sede_origen || '-',
        usuario: data.user,
        tipo_solicitud: data.tipo == TIPOS_SOLICITUD.RECURSOS ? 'Sedes' : 'Nacional',
        estado: data.estado,
        total: data.total,
        fecha_solicitud: data.created_at,
      };
      this.detalleSolicitud = data.detalle_solicitud?.map((detalle) => {
        this.cargando = false;

        return {
          id: detalle.id,
          sede_origen: detalle.sede_origen,
          banco_origen: detalle.banco_origen,
          cuenta_origen: detalle.cuenta_origen,
          sede_destino: detalle.sede_destino,
          banco_destino: detalle.banco_destino,
          cuenta_destino: detalle.cuenta_destino,
          detalle: detalle.detalle,
          estado: detalle.estado,
          importe: detalle.importe,
          observaciones: detalle.observaciones || '-',
          fecha_desembolso: detalle.fecha_desembolso
            ? moment(detalle.fecha_desembolso).format('DD/MM/YYYY HH:mm:ss')
            : '-',
          tipo_desembolso: detalle.tipo_desembolso || '-',
          archivo_id: detalle.archivo_id,
          detalle_solicitud_reversion_id: detalle.detalle_solicitud_reversion_id,
        };
      });
      this.dialog = true;
    },
    cerrar() {
      this.dialog = false;
      this.solicitud = null;
    },
    async obtenerArchivoAdjunto(detalleId) {
      this.detalleSeleccionadoId = detalleId;
      this.cargando = true;

      try {
        const { data } = await DetalleSolicitudService.obtenerArchivoAdjunto(detalleId);
        const { datos } = data;

        this.$refs.modalVerPdfRef.abrir(datos);
      } catch (error) {
        window.console.log(error);
        const response = error.response;
        const data = response?.data;
        const mensaje = data?.mensaje || 'Ocurrió un error al obtener el archivo adjunto';

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje,
          type: 'error',
        });
      } finally {
        this.cargando = false;
        this.detalleSeleccionadoId = null;
      }
    },
    abrirModalArchivo(detalleId, indice) {
      this.$refs.modalArchivoRespaldoRef.abrir(detalleId, indice);
    },
    actualizadoArchivoAdjunto(detalleSeleccionadoIndice, archivoId) {
      this.detalleSolicitud[detalleSeleccionadoIndice].archivo_id = archivoId;
      this.$refs.modalArchivoRespaldoRef.cerrar();
      this.$emit('actualizar');
    },
    async eliminarArchivoAdjunto(detalleId, indice) {
      this.detalleSeleccionadoId = detalleId;
      this.detalleSeleccionadoIndice = indice;
      this.cargando = true;

      try {
        await DetalleSolicitudService.eliminarArchivoAdjunto(detalleId);

        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: 'Archivo adjunto eliminado correctamente',
          type: 'success',
        });
        this.detalleSolicitud[this.detalleSeleccionadoIndice].archivo_id = null;
        this.detalleSeleccionadoId = null;
        this.detalleSeleccionadoIndice = null;
        this.$emit('actualizar');
      } catch (error) {
        window.console.log(error);
        const mensaje = error.response.data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Ocurrió un error al eliminar el archivo adjunto',
          type: 'error',
        });
      } finally {
        this.cargando = false;
      }
    },
    verHistorial(detalleId) {
      this.detalleSeleccionadoId = detalleId;
      this.$refs.modalVisualizarHistorialDetalleSolicitudRef.abrir(detalleId);
    },
    obtenerColorEstadoDetalleSolicitud: obtenerColorEstadoDetalleSolicitud,
  },
};
</script>